<template>
  <div>
    <b-row class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>{{ $t("catalogs.catalog_name") }} :</label>
        <ValidationProvider
          ref="vee-catalog-name"
          v-slot="{ errors, classes }"
          :name="'nom du catalog'"
          rules="required"
        >
          <b-input :value="resolutionCatalog.name" @input="updateCatalog('name', $event)"></b-input>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    resolutionCatalog: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    updateCatalog(key, value) {
      this.$emit("updateCatalog", key, value);
    },
  },
};
</script>
